const activityTypeTranslate: Record<string, string> = {
  'TYPE.EMAIL_CLIENT': 'Enviar Email',
  'TYPE.CALL_CLIENT': 'Realizar llamada telefónica',
  'TYPE.SHOW_VEHICLE': 'Mostrar vehículo',
  'TYPE.SEND_ESTIMATE': 'Enviar Cotización',
  'TYPE.OTHER': 'Otra',
}

export default activityTypeTranslate
